import { IHttpApi } from '@cian/http-api/';
import { IConfig } from '@cian/config/shared';

import { createRequestPayload } from './createRequestPayload';
import { TMappedAnswersState } from '../types';
import { fetchCreateMessage, TCreateMessageResponse } from '../../../repositories/demand/v5/create-message';
import { IApplicationState } from '../../../types/redux';
import { selectIsWebview } from '../../../selectors/selectIsWebview';
import { selectPage } from '../../../selectors/selectPage';

interface IParams {
  httpApi: IHttpApi;
  config: IConfig;
  mappedAnswersState: TMappedAnswersState;
  state: IApplicationState;
}

export const createRequest = async (params: IParams): Promise<TCreateMessageResponse> => {
  const { httpApi, mappedAnswersState, state } = params;
  const isWebview = selectIsWebview(state);
  const { platform, queryParams } = selectPage(state);

  const parameters = createRequestPayload({
    mappedAnswersState,
    isWebview,
    platform,
    queryParams,
  });

  return fetchCreateMessage({
    httpApi,
    parameters,
  });
};
